

require('./directive');

var _squid = require('squid');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddPhoneRoute', function () {

    return _squid.$ComponentRoute.extend('AddPhoneRoute', {

        name: 'addPhone',

        directive: 'xo-add-phone',

        titleContent: 'addPhone.addPhoneNumber',

        query: ['message'],

        trackingData: {
            templateName: 'addPhone.dust',
            fptiState: 'add_phone',
            pageGoal: 'Add Phone',
            buzname: {
                'fullpage': {
                    'pagename': '%::fullpage-add-phone',
                    'pagename2': '%::fullpage-add-phone:member:hermes:',
                    'version': 'member:%:'
                    // More page qualifiers come here...
                } }
        },

        loginRequired: true,

        children: []
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-form-components/src/phone/route.js
// module id = ../node_modules/xo-form-components/src/phone/route.js
// module chunks = 0